import { assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '../../../serialization/ENUM__dto_class_name';
import { DTO__database_entity } from '../../_database_entity/DTO__database_entity';
import { ENUM__user_role } from './ENUM__user_role';
import { IUser } from './IUser';

export class DTOUser extends DTO__database_entity implements IUser {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.USER;

  /*
   * FIELDS
   */
  role!: string;

  full_name!: string;
  url_relative_avatar!: string;

  user_number!: number;

  /*
   * DB FIELDS
   */
  email!: string;
  password_hash!: string;

  google_email!: string;
  microsoft_email!: string;
  github_email!: string;
  discord_email!: string;
  facebook_email!: string;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.role, ENUM__user_role);

    assert_string_not_empty(this.full_name);

    assert_string_not_empty(this.email);
  }
}
